/**
 * Сумма прописью по-русски (целые тенге, до 999 миллионов).
 * Кассир путает нули на устали — «сорок две тысячи» страхует глаз.
 */
const ONES = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const ONES_F = ['', 'одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const TEENS = ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать',
  'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'];
const TENS = ['', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят',
  'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'];
const HUNDS = ['', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот',
  'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'];

function triple(n: number, feminine: boolean): string {
  const ones = feminine ? ONES_F : ONES;
  const parts: string[] = [];
  if (n >= 100) parts.push(HUNDS[Math.floor(n / 100)]!);
  const rest = n % 100;
  if (rest >= 10 && rest < 20) parts.push(TEENS[rest - 10]!);
  else {
    if (rest >= 20) parts.push(TENS[Math.floor(rest / 10)]!);
    if (rest % 10 > 0) parts.push(ones[rest % 10]!);
  }
  return parts.join(' ');
}

function plural(n: number, forms: [string, string, string]): string {
  const r100 = n % 100; const r10 = n % 10;
  if (r100 >= 11 && r100 <= 14) return forms[2];
  if (r10 === 1) return forms[0];
  if (r10 >= 2 && r10 <= 4) return forms[1];
  return forms[2];
}

/** 4250000 тиын (42 500 ₸) → «сорок две тысячи пятьсот тенге» */
export function moneyInWords(tiyn: number): string {
  const t = Math.floor(Math.abs(tiyn) / 100);
  if (t === 0) return 'ноль тенге';
  const mil = Math.floor(t / 1_000_000);
  const th = Math.floor((t % 1_000_000) / 1000);
  const rest = t % 1000;
  const parts: string[] = [];
  if (mil > 0) parts.push(triple(mil, false), plural(mil, ['миллион', 'миллиона', 'миллионов']));
  if (th > 0) parts.push(triple(th, true), plural(th, ['тысяча', 'тысячи', 'тысяч']));
  if (rest > 0) parts.push(triple(rest, false));
  return parts.filter(Boolean).join(' ') + ' тенге';
}
